@if (!isLoading) {
  @if (isNLAccount && isEventExist && shareAllowed) {
    <div class="all-shared">
      <span
        >All Timelog Events are
        @if (!shareTimelogEventStatus) {
          <b>NOT </b>
        }
        shared with Customer Portal by default
      </span>
      <mat-slide-toggle
        [checked]="shareTimelogEventStatus"
        (change)="onTimeLogsChanged($event)"
      >
      </mat-slide-toggle>
    </div>
  }
  <div class="table-scroll-container">
    <cotecna-table
      [data]="(events | async) ?? []"
      [columns]="columns"
      [actions]="actions"
      [hasSelectableColumn]="false"
      [hasActionsTitle]="false"
      (click)="processAction($event)"
      (toggleChange)="onToggleChanged($event)"
      dateFormat="short"
    >
    </cotecna-table>
  </div>
  @if (allowCreate()) {
    <comat-fab-speed-dial
      id="addNewEventButton"
      [actions]="speedDialActions"
      (selectedAction)="onFabSpeedDialSelectedAction($event)"
      mainIcon="add"
      color="accent"
    >
    </comat-fab-speed-dial>
  }
}
@if (isLoading) {
  <mat-spinner diameter="32"></mat-spinner>
}
